module.exports = __webpack_public_path__ + "media/images/bulb-wakatta-c8a97b0623f847d3b73813745cb8bbb0.png";